<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'SummaryUsageList' }"
                ><i class="fas fa-chevron-left"></i>
              </router-link>
              Summary Usage
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">SummaryUsage</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="overlay" v-if="is_loading">
                <img src="/assets/images/loader.svg" alt="" />
              </div>
              <div class="card-header py-3">
                <h3 class="card-title">Detail</h3>
              </div>
              <div class="card-body">
                <div class="custom-list">
                  <ul>
                    <li><strong>ID</strong> {{ value.id }}</li>

                    <li><strong>User ID</strong> {{ value.userid }}</li>

                    <li><strong>Router MAC</strong> {{ value.ap_wi_mac }}</li>

                    <li><strong>Device MAC</strong> {{ value.device_mac }}</li>

                    <li><strong>Acttype</strong> {{ value.acttype }}</li>

                    <li>
                      <strong>Total Usages</strong> {{ value.total_usages }}
                    </li>

                    <li><strong>Download</strong> {{ value.download }}</li>

                    <li><strong>Upload</strong> {{ value.upload }}</li>

                    <li><strong>Attempted</strong> {{ value.attempted }}</li>

                    <li>
                      <strong>Usages Date</strong> {{ value.usages_date }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import axios from "axios";
import { Notification } from "element-ui";
const fileDownload = require("js-file-download");

export default {
  name: "SummaryUsageShow",
  metaInfo: {
    title: "SummaryUsage | Dotlines",
  },
  data: () => ({
    value: {},
    pre: {},
    is_loading: false,
  }),
  mounted: function () {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await this.getDetail(this.params.id).then((response) => {
        this.value = response.data;
      });

      this.is_loading = false;
    },
    downloadFile: function (url) {
      this.is_loading = true;
      axios
        .get(this.API_ASSET_UPLOAD_URL + url, { responseType: "arraybuffer" })
        .then((response) => {
          fileDownload(response.data, url.replaceAll("/", "-"));
          Notification.success({
            title: "Download Completed",
            message: "Download completed successfully",
            type: "success",
          });
        })
        .catch((error) => {
          Notification.error({
            title: "Download Failed",
            message: "Failed to download",
            type: "error",
          });
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line camelcase
        const api_url = "/summaryusages/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.log("error " + error);
            reject(error);
          })
          .finally(() => {});
      });
    },
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>
